import React from "react"
import { Container } from "reactstrap"
import styled from "styled-components"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import QuoteIcon from 'images/quote.svg'
import { media } from 'utils/Media'

const QuoteBlockStyles = styled.section`
    padding: 2rem 0;
    .quote {
        margin-bottom: 1rem;
    }
    h4 {
        font-family: ${props => props.theme.font.family.body};
        /* font-weight: ${props => props.theme.font.weight.black}; */
        line-height: 140%;
        font-weight: 700;
        font-size: ${props => props.theme.font.size.xl};
        @media ${media.md} {
            font-size: ${props => props.theme.font.size.xxxl};
        }
    }
    p {
        color: ${props => props.theme.colors.tertiary};
        margin-top: 1rem;
    }
`

const QuoteBlock = ({ data }) => {
    const { quote, quoteAuthor} = data
    if (quote) {
        return (
            <Container fluid className="pb-4">
                <QuoteBlockStyles>
                    <img src={QuoteIcon} className="quote" alt="" />
                    <h4>{quote}</h4>
                    <p>{quoteAuthor}</p>
                </QuoteBlockStyles>
            </Container>
        )
    } else {
        return ""
    }
}

export default QuoteBlock